import dynamic from 'next/dynamic';
import Drawer from '@/features/drawer';
import DrawerHeader from '@/features/drawer/drawer-header';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import MenuGrouping from './menu-grouping';
import { HeaderDrawerName } from '../../constants';
const MobileMenu = () => {
  return <Drawer name={HeaderDrawerName} position='right' withBackDrop className='overflow-y-hidden' data-sentry-element="Drawer" data-sentry-component="MobileMenu" data-sentry-source-file="mobile-menu.tsx">
            <DrawerHeader hasBackButton={false} htmlFor={HeaderDrawerName} title='دسته‌بندی‌ها' data-sentry-element="DrawerHeader" data-sentry-source-file="mobile-menu.tsx" />
            <MenuGrouping data-sentry-element="MenuGrouping" data-sentry-source-file="mobile-menu.tsx" />
        </Drawer>;
};
export default dynamic(() => Promise.resolve(MobileMenu), {
  ssr: PUBLIC_IS_BOT
});